import { format } from "date-fns"
import Image from "next/image"
import Link from "next/link"
import type { PostMeta } from "@/lib/content"

const BlogLayoutThree = ({ blog }: { blog: PostMeta }) => {
  return (
    <div className="group blog-card">
      {
        blog.image &&
        <Link href={blog.url} className="blog-card-media">
          <Image
            src={blog.image.src}
            placeholder="blur"
            blurDataURL={blog.image.blurDataURL}
            title={blog.title}
            alt={`Cover Image of ${blog.title}`}
            width={blog.image.width}
            height={blog.image.height}
            className="blog-card-img"
            sizes="(max-width: 640px) 100vw,(max-width: 1024px) 50vw, 33vw"
          />
        </Link>
      }

      <div className="flex flex-col w-full mt-4">
        {
          blog.tags && blog.tags.length > 0 &&
          <span className="blog-card-tag">
            {blog.tags[0]}
          </span>
        }
        <Link href={blog.url} className="inline-block my-1">
          <h2 className="blog-card-heading">
            <span
              className="blog-title"
            >
              {blog.title}
            </span>
          </h2>
        </Link>

        <span className="blog-card-date">
          {format(new Date(blog.publishedAt), "MMMM dd, yyyy")}
        </span>
      </div>
    </div>
  );
};

export default BlogLayoutThree;
